import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux'

// components
import HarborList from "./_list";
import HarborForm from "./_form";
import NewItemButton from "../../../components/genericComponents/NewItemButton";

// actions
import { clearState } from '../../../redux/actions/genericActions'
import { clearFilters } from '../../../redux/actions/filterActions'
import {setApp, clearState as clearMainState} from "../../../redux/actions/generalActions/mainActions";

const Harbor = props => {
	const { viewMode } = props.info

	useEffect(() => {
		if (props.app !== null)
			props.setApp(props.app);

		return () => {
			props.clearState()
			props.clearFilters()
			props.clearMainState()
		}
	}, []);

	return (<>
		<NewItemButton />

		<Row>
			<Col md="12">
			{(
				function() {
					switch (viewMode) {
						case "LIST" :
							return <HarborList app={props.app} />
						case "FORM" :
							return <HarborForm app={props.app}/>
						default:
							return null;
					}
				})()}
			</Col>
		</Row>
	</>);
}

const mapStateToProps = state => ({ info : state.genericInfo })
const mapActionsToProps = ({ clearState, clearFilters, clearMainState, setApp })

export default connect(mapStateToProps, mapActionsToProps)(Harbor)